(function () {
  function isHidden(el) {
    if (!el) return true;
    return window.getComputedStyle(el).display === 'none' || window.getComputedStyle(el).visibility === 'hidden';
  }

  function fixHiddenOrDisabledCheckedOptions() {
    document.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach(function (fieldset) {
      var checkedInput = fieldset.querySelector('input[type="radio"]:checked');

      if (!checkedInput) return;

      var checkedLabel = fieldset.querySelector('label[for="' + checkedInput.id + '"]');

      var checkedIsBad =
        checkedInput.disabled ||
        checkedInput.classList.contains('disabled') ||
        isHidden(checkedInput) ||
        isHidden(checkedLabel);

      if (!checkedIsBad) return;

      var availableInputs = Array.from(fieldset.querySelectorAll('input[type="radio"]')).filter(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');

        return (
          !input.disabled &&
          !input.classList.contains('disabled') &&
          !isHidden(input) &&
          !isHidden(label)
        );
      });

      if (!availableInputs.length) return;

      availableInputs[0].click();
    });
  }

  function scheduleFix() {
    setTimeout(fixHiddenOrDisabledCheckedOptions, 50);
    setTimeout(fixHiddenOrDisabledCheckedOptions, 200);
    setTimeout(fixHiddenOrDisabledCheckedOptions, 500);
  }

  document.addEventListener('DOMContentLoaded', scheduleFix);

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('variant-selects input[type="radio"]') ||
      event.target.matches('variant-radios input[type="radio"]')
    ) {
      scheduleFix();
    }
  });
})();